import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var content = createRuntimeFn({defaultClassName:'fx_2d2fb1e5_1av9y6a0 fx_2d2fb1e5_17el7vp2',variantClassNames:{prefersReducedMotion:{noPreference:'fx_2d2fb1e5_1av9y6a1',reduce:'fx_2d2fb1e5_1av9y6a2'}},defaultVariants:{},compoundVariants:[]});
var contentInner = 'fx_2d2fb1e5_1av9y6a4 fx_2d2fb1e5_17el7vp3';
var contentMinWidth = 'fx_2d2fb1e5_1av9y6a3';

export { content, contentInner, contentMinWidth };
//# sourceMappingURL=clickPopover.vanilla.mjs.map
